import { Button, IconButton, Skeleton, Stack, TableCell, Tooltip, Typography } from '@mui/material';
import { AssignedDoctorsCells, AssignedUsersCells, assignUser, getAssignedDoctors, getAssignedUsers, getUsers, unassignUser } from 'framework/user';
import useFetchSection from 'hooks/useFetchSection';
import List from '../List';
import EmptyContent from 'components/EmptyContent';
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { IAssignedDoctors, IAssignedUsers, IUser } from 'models/user';
import { useEffect, useState } from 'react';
import { useAlert } from 'contexts/alertContext';
import { handleError } from 'helpers/utils';
import { QueryClient, useMutation } from 'react-query';
import EditModalReseller from './partials/Edit';
import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import { Delete } from '@mui/icons-material';
import DeleteModal from '../Form/partials/Delete';

interface Props {
    slugId: string
}
function AssignDoctorList({ slugId }: Props) {
    const [loading2, setLoading2] = useState(false)
    const [inputObj, setInputObj] = useState<{ doctorId: number, patientId: number }>({} as { doctorId: number, patientId: number });
    const [openEdit, setOpenEdit] = useState<boolean>(false);
    const [openDelete, setOpenDelete] = useState<boolean>(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const handleChange = (name: string, value: any) => {
        setInputObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const { setAlert } = useAlert();

    const handleOpenEdit = () => {
        setOpenEdit(true);
    };

    const assignUserMutation = useMutation({
        mutationFn: (doctorID: number) => {
            return assignUser({ doctorID, patientID: +slugId! });
        },
    });

    const unassignUserMutation = useMutation({
        mutationFn: (doctorID: number) => {
            return unassignUser({ doctorID, patientID: +slugId! });
        },
    });

    const queryClient = new QueryClient();
    const [users, setUsers] = useState<IUser[]>([])
    const handleClose = () => {
        setOpenEdit(false)
        setOpenDelete(false)
        setSelectedId(null)
        setInputObj({} as { patientId: number, doctorId: number })
    }

    const handleOpenDelete = (id: number) => {
        setOpenDelete(true);
        setSelectedId(id)
    };

    const {
        loading,
        data: Assigned,
        error,
        revalidate,
    } = useFetchSection({
        fetchData: () => getAssignedDoctors(slugId),
        fetchPermission: async () => null,
        section: "Assigned Doctors"
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await queryClient.fetchQuery("get Doctors list", () => getUsers('\\2'));
                setUsers(response.data)
            } catch (error) {
                console.error('Failed to fetch dropdown data:', error);
            }
        };

        fetchUsers();
    }, []);

    if (loading)
        return (
            <Stack spacing={2} p={2}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <Skeleton variant="rectangular" key={i} width="100%" height={30} />
                ))}
            </Stack>
        );




    const filteredUsers = users.filter(user =>
        !(Assigned || []).some(assigned => assigned.doctorId === user.userId)
    );

    let countriesOptions = filteredUsers.map((user) => { return { value: user?.userId.toString(), label: (user.firstName + user?.lastName).toString() } });

    const getBodyCells = (row: IAssignedDoctors) => {
        let cells = Object.keys(row).map((key: string, i: number) => {

            if (key === "doctorId")
                return {
                    id: "action",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Stack
                                direction={"row"}
                                alignContent={"center"}
                                spacing={1}
                            >
                                <Tooltip title={"Unassign"}>
                                    <IconButton
                                        size={"small"}
                                        sx={{
                                            color: "red",
                                        }}
                                        onClick={() => handleOpenDelete(row.doctorId)}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Tooltip>


                            </Stack>
                        </TableCell>),
                };

            if (key === "firstName")
                return {
                    id: "firstName",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.firstName}</Typography>
                        </TableCell>
                    ),
                };
            if (key === "lastName")
                return {
                    id: "lastName",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.lastName}</Typography>
                        </TableCell>
                    ),
                };




        });
        return cells;
    };




    let editBasicFields: IFormField[] = [
        {
            name: 'doctorId',
            label: 'Doctors',
            type: InputTypes.SELECT,
            options: countriesOptions,
            placeholder: 'Select Doctor',
            internalLabel: true,
            required: true
        }
    ];

    const handleAssign = async () => {
        try {
            setLoading2(true)
            await assignUserMutation.mutateAsync(+inputObj.doctorId);
            setAlert({
                open: true,
                message: `Doctor assigned successfully`,
                type: "success",
            });
            setLoading2(false)
            handleClose()
            revalidate();
        } catch (error: any) {
            setAlert({
                open: true,
                message: handleError(error) || "Something went wrong",
                type: "error",
            });
            setLoading2(false)
        }

    };

    const handleUnassign = async () => {
        try {
            setLoading2(true)
            await unassignUserMutation.mutateAsync(selectedId!);
            setAlert({
                open: true,
                message: `Doctor unassigned successfully`,
                type: "success",
            });
            setLoading2(false)
            handleClose()
            revalidate();
        } catch (error: any) {
            setAlert({
                open: true,
                message: handleError(error) || "Something went wrong",
                type: "error",
            });
            setLoading2(false)
        }

    };

    const AssignedSafe = Assigned || []
    return (
        <div>
            {AssignedSafe!.length === 0 && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBlock: 10 }}> <Button onClick={handleOpenEdit} variant='contained'>Assign a doctor</Button> </div>}

            {AssignedSafe!.length > 0 && (
                <List
                    headCells={AssignedDoctorsCells}
                    data={AssignedSafe!}
                    getBodyCells={getBodyCells}
                    canEdit={false}
                />
            )}
            {(!AssignedSafe || AssignedSafe.length === 0) &&

                <EmptyContent
                    icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                    header={"No Assigned Doctor"}
                    message={`No Assigned Doctors Yet`}
                />
            }

            {openEdit && (
                <EditModalReseller
                    loading={loading2}
                    open={openEdit}
                    title={`Assign Doctor`}
                    basicFields={editBasicFields}
                    onClose={handleClose}
                    onSubmit={handleAssign}
                    onChanges={handleChange}
                />
            )}

            {openDelete && (
                <DeleteModal
                    loading={loading2}
                    open={openDelete}
                    title={`Unassign Doctor`}
                    buttonText='Unassign'
                    description='Are you sure to unassign this doctor?'
                    onClose={handleClose}
                    onSubmit={handleUnassign}
                />)}
        </div>
    )
}

export default AssignDoctorList